import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton } from "../neu/Neu";
import { issuePrintLink, printUrl } from "../../api/docPrint";

// زر مستند رسمي: يُصدر رابط JWT (24 ساعة) ويفتح المستند بتصميم القاعدة الذهبية.
export const OfficialDocButton = ({ kind, docId, label, testId, copy = "" }) => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);

  const open = async () => {
    setBusy(true);
    try {
      const link = await issuePrintLink(kind, docId);
      const url = printUrl(link) + (copy ? `&copy=${copy}` : "");
      window.open(url, "_blank", "noopener");
    } catch (error) {
      toast.error(error?.response?.data?.detail?.code || t("errors.generic"));
    }
    setBusy(false);
  };

  return (
    <NeuButton className="w-fit px-3 py-2 text-xs" disabled={busy} onClick={open}
               data-testid={testId || `official-doc-${kind}-${docId}`}>
      {label || t("docs.openOfficial")}
    </NeuButton>
  );
};
